import React from 'react';
import {
    Row, Col,
} from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import Widget from '../../components/Widget';
import s from './consultants.module.scss';
import ConsultantsBySectional from "../../components/consultant/Sectional";


class Consultants extends React.Component {


    render() {
        return (
            <div className={s.root}>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">Estas en</li>
                    <li className="breadcrumb-item active">Asesores Pais</li>
                </ol>
                <h1 className="page-title"><span className="fw-semi-bold">Asesores País</span>
                </h1>

                <Widget title={<h6> Asesores </h6>} close collapse settings>
                    <Row>
                        <Col lg="12" xs="10">
                            <div>
                                {/*filtro <TimeFilter />*/}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12" xs="100%">
                            <div className="location-selector">
                                <ConsultantsBySectional />
                            </div>
                        </Col>
                    </Row>
                </Widget>
            </div>
        );
    }
}

// function mapStateToProps(state) {
//     return {
//         isFetching: state.filtroTiempo.isFetching,
//         filtroTiempo: state.filtroTiempo.filtroTiempo,
//     };
// }
//export default connect(mapStateToProps)(PrincipalDashboard);
export default Consultants;

//export default PrincipalDashboard;
